import React, {useEffect} from 'react';
import Schedule from './Schedule';
import PlanSelect from './PlanSelect';
import Search from './Search';
import Detail from './Detail';
import About from './About';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { getDatabase, ref, set as FirebaseSet, onValue, push as FirebasePush, get, remove as FirebaseRemove} from 'firebase/database';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import Login from './Login';


export default function Wrapper(props) {

    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseConfig = {
    apiKey: "AIzaSyDbxgtj31yzUHCzFUwb0GqwPTXKHAnyv_A",
    authDomain: "myplan-beta.firebaseapp.com",
    databaseURL: "https://myplan-beta-default-rtdb.firebaseio.com",
    projectId: "myplan-beta",
    storageBucket: "myplan-beta.appspot.com",
    messagingSenderId: "1086814229011",
    appId: "1:1086814229011:web:15a8972bcb5988e202a5e6",
    measurementId: "G-WFJRYZ9S6C"
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const db = getDatabase();

    const [plans, setPlan] = React.useState([]);
    const [currPlan, setCurrPlan] = React.useState(0);
    const [selectedCourse, setCourse] = React.useState([]);

    useEffect(() => {

        const allDataRef = ref(db, "users/" + props.currUser.name);
        onValue(allDataRef, (snapshot) => {
            if (snapshot.exists()) {
                const allDataObj = snapshot.val();
                delete allDataObj.placeholder;
                const allDataKeys = Object.keys(allDataObj);
                if (allDataKeys.length > 0) {
                    setCurrPlan(allDataKeys[0]);

                    setPlan(allDataKeys.map((key) => {
                        const singleData = {...allDataObj[key], "key": key};
                        if (!Object.keys(singleData).includes("plan")) {
                            singleData['plan'] = [];
                        }
                        return singleData;
                    }));
                }
                else {
                    setCurrPlan([]);
                    setPlan([]);
                }

            } else {
            console.log("No data available");
            }
        })

    }, [props.currUser]);

    const changeDatabasePlan = (newPlans) => {
        setPlan(newPlans);
        var location = "users/" + props.currUser.name;
        const courseUpload = ref(db, location);
        FirebaseRemove(courseUpload);
        newPlans.forEach((plan) => {
            plan['key'] = null;
            FirebasePush(courseUpload, plan)
        });
        const placeholder = {"placeholder": 0};
        const placeholderRef = ref(db, location + "/placeholder");
        FirebaseSet(placeholderRef, placeholder);
    }

    var currLoc = useLocation();
    var currPage = currLoc.pathname.substring(1);
    var title = (<h1>
        Loading
    </h1>);
    var classStr = "flex-grow-1 align-self-center";
    
    if (currPage === "schedule") {
        title = (<h1>
            Schedule<br />
            Builder
        </h1>);
        classStr = (props.expandPlan ? " title expand" : " title");
    }
    else if (currPage === "search") {
        title = (<h1>
            Search<br />
            Courses
        </h1>);
        classStr = (props.expandPlan ? " title expand" : " title");
    }
    else if (currPage.includes('detail')) {
        title = (<h1 className={'detail'}>
            {decodeURIComponent(currPage.substring(currPage.indexOf("/") + 1))}
        </h1>);
        classStr = (props.expandPlan ? " title expand" : " title");
    }
    else if (currPage === "login") {
        title = (<h1>
            Login / Signup
        </h1>);
        props.setExpand(false);
        classStr = " title";
    }
    else if (currPage === "about") {
        title = (<h1>
            About
        </h1>);
        props.setExpand(false);
        classStr = " title";
    }

    var expandStr = (props.expandPlan ? " expand" : "");

    return (

        <div className="wrapper">
        <main>    
            <div className="title-block d-flex">
                <div className={["flex-grow-1 align-self-center" + classStr]}>
                    {title}
                </div>
                <div className="flex-grow-0 align-self-center plan-more"  style={{display: currPage==="about" || currPage==="login" ? "none" : "block"}}>
                    <button id='expandplan' className={['exp-btn' + expandStr]} onClick={() => {props.setExpand(!props.expandPlan)}} >
                        <span className="material-icons md-48">
                            keyboard_arrow_left
                        </span>
                    </button>
                </div>

                <PlanSelect setCourse={setCourse} style={currPage==="about" || currPage==="login" ? "none" : "block"} expandPlan={props.expandPlan} plans={plans} currPlan={currPlan} setCurrPlan={setCurrPlan} username={props.currUser.name}/>
            </div>

            <Routes>
                <Route path='login' element={<Login currUser={props.currUser} setUser={props.setUser}/>} />
                <Route path='about' element={<About />} />
                <Route path='detail/:courseDetail' element={<Detail plans={plans} setPlan={setPlan} username={props.currUser.name}/>} ></Route>
                <Route path='search' element={<Search selectedCourse={selectedCourse} setCourse={setCourse} plans={plans} setPlan={changeDatabasePlan} username={props.currUser.name} />} />
                <Route index path='schedule' element={<Schedule selectedCourse={selectedCourse} setCourse={setCourse} setPlan={changeDatabasePlan} currPlan={currPlan} plans={plans} username={props.currUser.name}/>} />
                <Route path='*' element={<Navigate to={"schedule"}/>} />
            </Routes>

        </main>
    
        <footer style={{display: "block"}}>
            <div className="links">
                <a href="https://www.flaticon.com/free-icons/book" target={"_blank"} title="book icons">Book icons created by Smashicons - Flaticon</a>
                <div>
                    Sidebar background by <a href='https://unsplash.com/@heeyeuni91?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText' target={"_blank"}>Eunice Choi</a> on <a href="https://unsplash.com/s/photos/university-of-washington?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText" target={"_blank"}>Unsplash</a>
                </div>
            </div>

        </footer>
        </div>
    );

}